import { useState } from 'react';
import { useSignInEmailPassword } from '@nhost/react';
import { useNavigate } from 'react-router-dom';

export function LoginPage() {
  const { signInEmailPassword, isLoading, isError, error } = useSignInEmailPassword();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    const res = await signInEmailPassword(email, password);
    if (res.isSuccess) navigate('/');
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={onSubmit}>
        <div className="login-brand">
          <img src="/tomi-icon.png" alt="" />
          <span>Tomi Reviews</span>
        </div>
        <h1>Anmelden</h1>
        <p className="sub">
          Melde dich mit deiner Tomi-Reviews-Adresse an, um auf das Backend zuzugreifen.
        </p>
        <div className="login-field">
          <label htmlFor="email">E-Mail</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
        </div>
        <div className="login-field">
          <label htmlFor="password">Passwort</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className="btn primary"
          style={{ width: '100%', justifyContent: 'center', padding: '12px 20px' }}
          disabled={isLoading}
        >
          {isLoading ? 'Anmelden…' : 'Anmelden'}
        </button>
        {isError && <p className="login-error">{error?.message}</p>}
      </form>
    </div>
  );
}
